import type { IEventBus } from "@/domains/events"

import { VoteNamespace } from "./types"
import { VoteOrchestratorFactory } from "./vote-orchestrator-factory"
import { VoteStore } from "./vote-store"

export type VoteNamespaceFactoryParams = {
  eventBus: IEventBus
}

export const VoteNamespaceFactory = {
  create({ eventBus }: VoteNamespaceFactoryParams): VoteNamespace {
    const voteStore = new VoteStore(eventBus)

    const voteOrchestrator = VoteOrchestratorFactory.create(voteStore, eventBus)

    return {
      Store: voteStore,
      Orchestrator: voteOrchestrator,
    }
  },
}
